import axios from "axios";
import router from "@/router";
import mock from "./mock/mock.js";

const baseURL = process.env.VUE_APP_API_DOMAIN + "/";

const API = axios.create({
  baseURL,
  withCredentials: true,
});

API.interceptors.request.use(config => {
  const url = new URL(window.location.href);
  const pathSegments = url.pathname.split("/").filter(segment => segment.length > 0);
  
  let baseUrl = url.origin;

  // 最初のパスセグメントが存在する場合はURLに追加
  if (pathSegments.length > 0) {
    baseUrl += "/" + pathSegments[0];
  }

  // 'Current-Page-Url' ヘッダーにbaseUrlをセット
  config.headers["Current-Page-Url"] = baseUrl;
  return config;
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // BFF APIのみcatchする
    if (error.response) {
      if (
        process.env.VUE_APP_API_DOMAIN + "/" ===
        error.response.config.baseURL
      ) {
        console.log("error.response >>> ", error.response);

      }

      const statuscode = error.response.status;
      if (
        statuscode == 401 &&
        error.response.config.url != "/session-time-out"
      ) {
        router.push("/session-time-out");
      }

      return {
        ...error.response,
        isError: true,
      };
    } else {
      return false;
    }
  }
);

// モック起動処理
if (process.env.VUE_APP_DEV_MODE === "local") {
  mock.run(API);
}

export default API;
